import { Card } from 'antd';
import React, { } from 'react';
import "react-lightbox-pack/dist/index.css";


// https://github.com/biggora/device-uuid
import { DeviceUUID } from "device-uuid"
import PageLayout from '../../components/PageLayout';
// https://github.com/darcyclarke/Detect.js
var detect = require('detect.js');
var md5 = require('md5');



export default function AdminMainDeviceInfo(props) {
	const du = new DeviceUUID({
		version: false,
		language: false,
		platform: true,
		os: true,
		pixelDepth: true,
		colorDepth: true,
		resolution: false,
		isAuthoritative: true,
		silkAccelerated: true,
		isKindleFire: true,
		isDesktop: true,
		isMobile: true,
		isTablet: true,
		isWindows: true,
		isLinux: true,
		isLinux64: true,
		isChromeOS: true,
		isMac: true,
		isiPad: true,
		isiPhone: true,
		isiPod: true,
		isAndroid: true,
		isSamsung: true,
		isSmartTV: true,
		isRaspberry: true,
		isBlackberry: true,
		isTouchScreen: true,
		isOpera: false,
		isIE: false,
		isEdge: false,
		isIECompatibilityMode: false,
		isSafari: false,
		isFirefox: false,
		isWebkit: false,
		isChrome: false,
		isKonqueror: false,
		isOmniWeb: false,
		isSeaMonkey: false,
		isFlock: false,
		isAmaya: false,
		isPhantomJS: false,
		isEpiphany: false,
		source: false,
		cpuCores: false
	})

	// let t = now()
	// console.log(du.get())
	// console.log(du.parse())
	// var dua = [
	//     du.language,
	//     du.platform,
	//     du.os,
	//     du.cpuCores,
	//     du.isAuthoritative,
	//     du.silkAccelerated,
	//     du.isKindleFire,
	//     du.isDesktop,
	//     du.isMobile,
	//     du.isTablet,
	//     du.isWindows,
	//     du.isLinux,
	//     du.isLinux64,
	//     du.isMac,
	//     du.isiPad,
	//     du.isiPhone,
	//     du.isiPod,
	//     du.isSmartTV,
	//     du.pixelDepth,
	//     du.isTouchScreen
	// ];
	// console.log(du, du.hashMD5(dua.join(':')))
	// console.log(now()-t)	
	// t = now()
	// console.log(new DeviceUUID().parse())
	// console.log(now()-t)
	// t = now()
	// console.log(new DeviceUUID().get())
	// console.log(now()-t)
	// t = now()
	let detectParse = detect.parse(navigator.userAgent)
	// console.log(detectParse)
	let dua = [
		detectParse.browser.family,
		detectParse.device.family,
		detectParse.device.name,
		detectParse.device.type,
		detectParse.os.family,
		detectParse.os.name,
	];

	let detectMsg = dua.join(':');
	let detectUid = md5(detectMsg);
	// console.log(now()-t)



	return (
		<PageLayout>
			<Card>
				{du && <pre>
					<div>detectUid: {detectUid}</div>
					<div>detectMsg: {detectMsg}</div>
					<div>detect: {JSON.stringify(detect.parse(navigator.userAgent), null, 2)}</div>
					<div>uuid: {JSON.stringify(du.get())}</div>
					<div>data: {JSON.stringify(du.parse(), null, 2)}</div>
				</pre>}
			</Card>
		</PageLayout>
	);
}
